import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { DataModule } from '@data/data.module';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TokenInterceptor } from '@core/interceptor/token.interceptor';
import { ErrorInterceptor } from '@core/interceptor/error.interceptor';
import { ApolloModuleService } from '@core/graphql/apollo-module.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    // Angular
    BrowserModule,
    // ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.PRODUCTION }),
    HttpClientModule,
    FormsModule,
    CommonModule,
    DragDropModule,
    // ApolloModule,
    ApolloModuleService,

    // Core & Shared
    CoreModule,
    DataModule,

    // App
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
